import { render, staticRenderFns } from "./EditBrandingModal.vue?vue&type=template&id=6b9a7d42&scoped=true&"
import script from "./EditBrandingModal.vue?vue&type=script&lang=js&"
export * from "./EditBrandingModal.vue?vue&type=script&lang=js&"
import style0 from "./EditBrandingModal.vue?vue&type=style&index=0&id=6b9a7d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a7d42",
  null
  
)

export default component.exports